<app-modal-title>
  <div i18n>Patch download confirmation</div>
</app-modal-title>
<app-modal-body [height]="height" [minheight]="minheight">
  <div>
    <div class="ot-panel__header">
      <app-tabs [identifier]="'patch-selection-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
        [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
    </div>
    @if (activeTab == PatchSelectionTab.SUPERSEDED) {
    <div>
      <div class="ot-message ot-message--is-info">
        <div class="ot-message__banner">
          <p class="title" i18n>
            '{{patch.name}}' has been superseded. It is recommended that you proceed with the selected patch below
          </p>
        </div>
      </div>
      <ng-scrollbar [ngStyle]="{'width': '100%', 'height': '240px'}">
        <div class="ot-row ot-pl-1 ot-pt-1 ot-pr-1 ot-pd-1">
          <div class="ot-form-control">
            <label class="ot-form-control__label" i18n>Available patches</label>
            <div class="ot-radio-group">
              <div class="ot-radio-options">
                @for (patch of supersededByPatches; track patch; let i = $index) {
                <label class="ot-radio">
                  <input type="radio" [name]="patch.name" [value]="patch" [(ngModel)]="supersededPatch">
                  <span class="ot-radio__wrapper">
                    <span class="ot-radio__icon">
                    </span>
                    <span class="ot-radio__text" [title]="patch.description">{{getSupersededOption(patch)}}</span>
                  </span>
                </label>
                }
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
    }
    @if (activeTab == PatchSelectionTab.DEPENDENT) {
    <div>
      <div class="ot-message ot-message--is-info">
        <div class="ot-message__banner">
          <p class="title" i18n>
            '{{patch.name}}'' requires the following additional patch(es) to be automatically selected for download
          </p>
        </div>
      </div>
      <div class="table-container">
        <app-datatable [identifier]="'dependent-patches-table'" [disableSelectAllCheckbox]="true"
          [cols]="dependentTableCols" [showcheckboxes]="true" [rows]="dependentTableRows"></app-datatable>
      </div>
    </div>
    }
  </div>
</app-modal-body>
<app-modal-footer>
  <button class="ot-btn ot-btn--is-primary" i18n-title title="Confirm" (click)="confirm()" i18n>
    Confirm
  </button>
  <button class="ot-btn ot-btn--is-secondary" i18n-title title="Cancel" (click)="cancel()" i18n>
    Cancel
  </button>
</app-modal-footer>